import React from "react";

const Footer = () => {
	return (
		<div className="footer">
			<p>
				Airport Taxi Transfers Varna Ltd. <br />
				Airport Taxi Transfers Varna is a trademark of Airport Taxi Transfers Varna Ltd. All rights reserved.
			</p>
		</div>
	);
};

export default Footer;